const AttackKeys = {
  Slash: 'Slash',
  Shoot: 'Shoot',
  Thrust: 'Thrust',
};

export default AttackKeys;
